const metrics = state => state.metrics

const onlineAudiologists = state => state.onlineAudiologists

const requests = state => state.requests

const infoTypes = state => state.infoTypes

const accessTypes = state => state.accessTypes

const pendingRequest = state => state.pendingRequest

const activeRequest = state => state.activeRequest

const inCall = state => state.pendingRequest !== null || state.activeRequest !== null

const activeBreak = state => state.activeBreak

const inBreak = state => state.activeBreak !== null

const appointmentTypes = state => state.appointmentTypes


export default {
  inCall,
  inBreak,
  metrics,
  requests,
  infoTypes,
  activeBreak,
  accessTypes,
  activeRequest,
  pendingRequest,
  onlineAudiologists,
  appointmentTypes
}
